import { Wizard } from "./wizard";
import { WizardStep } from "./wizard-step";

/** ###TypeDocName:sd-wizard-button### */
export class WizardButtonBinding {
  /** The text that should appear in the button. */
  buttonLabel = "@";
  /** The step to take the wizard to after this button is clicked. */
  targetStep = "@";
  /** The automation id to use for this button. */
  automationId = "@";
  /** Callback invoked when the button is clicked -- will not be invoked if the button is disabled. There are no arguments to this callback invocation. */
  onClick = "&?";
  /** True if this button should be disabled, false otherwise. */
  isButtonDisabled = "<";
  /** True if this button should finish the wizard flow, false otherwise. */
  isFinishButton = "<";
  /** True if this button should go back when clicked, false otherwise. */
  isGoBackButton = "<";
  /** True if button should be styled as a submit button. */
  isSubmitButton = "<";
  /** True if button should be assigned as type button. */
  isOkButton = "@?";
}

export interface WizardButton {
  buttonLabel: string;
  onButtonClicked: () => void;
  isStepEnabled: boolean;
}

export class WizardButtonController implements WizardButton {
  public parentWizard: Wizard;
  public parentStep: WizardStep;
  public buttonLabel: string;
  public isStepEnabled: boolean;
  public isFinishButton: boolean;
  public isGoBackButton: boolean;
  public targetStep: string;
  public isButtonDisabled: boolean;
  public automationId: string;
  public onClick: (args: {}) => void;

  public $onInit() {
    this.parentStep.registerStepButton(this);
  }

  public onButtonClicked() {
    if (this.isButtonDisabled) {
      return;
    }

    if (this.onClick) {
      this.onClick({
        busyPromiseSetter: (promise: ng.IPromise<any>) => {
          this.parentWizard.setWizardBusy(promise);
        }
      });
    }

    if (this.isFinishButton) {
      this.parentStep.finish();
    } else if (this.isGoBackButton) {
      this.parentStep.goBack();
    } else {
      this.parentStep.advanceWizard(this.targetStep);
    }
  }
}
export const sdWizardButton: ng.IComponentOptions = {
  bindings: <any>new WizardButtonBinding(),
  controller: WizardButtonController,
  require: {
    parentStep: "^sdWizardStep",
    parentWizard: "^^sdWizard"
  }
};
